import { createContext } from 'react';

const MyConText = createContext();

export default MyConText;
